export enum SEARCH_FILTER_KEYS {
  ACREAGE = 'acreage',
}

export enum SEARCH_FILTER_PROPERTIES {
  MIN = 'min',
  MAX = 'max',
}

export type SearchAcreageFilterValue = {
  min: number
  max: number
}

export const SEARCH_FILTER_DEFAULTS = {
  [SEARCH_FILTER_KEYS.ACREAGE]: {
    [SEARCH_FILTER_PROPERTIES.MIN]: 0,
    [SEARCH_FILTER_PROPERTIES.MAX]: 500,
  },
}
